{
  "label": "Kennzeichnung",
  "name": "Name",
  "gamme": "Sortiment",
  "serialNumber": "Seriennummer",
  "firmwareVersion": "Firmware-Version",
  "status": "Status",
  "sector": "Sektor",
  "certificate": "Zertifikat",
  "connectivity": "Konnektivität",
  "applicationDate": "Anwendungsdatum",
  "date": "Datum",
  "startDate": "Startdatum",
  "endDate": "Enddatum",
  "id": "ID",
  "search": "Suchen"
}
